<div class="offcanvas offcanvas-end" tabindex="-1" [id]="idOffcanvas">
    <div class="offcanvas-header">
        <h5 class="desktop_body_p5 m-0 d-flex align-items-center">
            <button class="btn" *ngIf="btnVoltar" type="button" (click)="voltar()">
                <img src="assets/imgs/icones/back-vermelho.svg" alt="">
            </button>
            {{titulo}}
        </h5>
        <button type="button" class="btn-close text-black" (click)="offcanvas.hide()" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body pt-0">
        <ng-content></ng-content>
    </div>
</div>